package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.layouts.PageLayout
import com.arena_web.ui.sections.info.InfoBullet
import com.arena_web.ui.sections.info.InfoPageScaffold
import com.arena_web.ui.sections.info.InfoParagraph
import com.arena_web.ui.sections.info.InfoSection
import com.varabyte.kobweb.core.Page

@Page("/privacy")
@Composable
fun PrivacyPage() {
    PageLayout(
        title = "Privacy Policy",
        description = "Privacy Policy for Arena Pro Play.",
        mobileReady = true,
    ) {
        InfoPageScaffold(title = "Privacy Policy") {
            InfoSection("1. Overview") {
                InfoParagraph(
                    "This policy explains what data Arena Pro Play (\"Arena\", \"we\", \"us\") collects, how we use " +
                        "it, and the choices you have. We collect only what we need to run a sports community that " +
                        "connects you with games and players nearby."
                )
            }
            InfoSection("2. Data we collect") {
                InfoBullet("Account data: name, email, and the profile details you choose to add (sports, level, photo).")
                InfoBullet("Location data: the city or area you select, used to show you relevant events and players nearby.")
                InfoBullet("Activity data: events you create or join, follows, and messages you send through the service.")
                InfoBullet("Technical data: device and browser information, and basic analytics about how the service is used.")
            }
            InfoSection("3. How we use your data") {
                InfoBullet("To operate the service: matching you with events, showing your profile to other players, delivering messages.")
                InfoBullet("To keep Arena safe: preventing abuse, fraud, and violations of our Terms of Service.")
                InfoBullet("To improve the product: understanding which features are used and where things break.")
                InfoBullet("To communicate with you about your account and activity relevant to you.")
            }
            InfoSection("4. What we don't do") {
                InfoBullet("We do not sell your personal data.")
                InfoBullet("We do not share your precise location with other users — they only see what you choose to show.")
                InfoBullet("We do not read your private messages except where required for safety investigations or by law.")
            }
            InfoSection("5. Sharing") {
                InfoParagraph(
                    "Parts of your profile and the events you join are visible to other users — that is how the " +
                        "community works. Beyond that, we share data only with service providers that help us run " +
                        "Arena (such as hosting and analytics), under contracts that protect your data, or when " +
                        "required by law."
                )
            }
            InfoSection("6. Cookies and storage") {
                InfoParagraph(
                    "We use cookies and browser storage to keep you signed in and remember your preferences such as " +
                        "language and selected sport. You can manage cookie consent at any time via the cookie banner " +
                        "settings."
                )
            }
            InfoSection("7. Your rights") {
                InfoParagraph(
                    "You can access and update your profile data in settings, and request a copy or deletion of your " +
                        "data at any time. Deleting your account removes your profile and personal data, except where " +
                        "we are legally required to retain certain records."
                )
            }
            InfoSection("8. Data retention and security") {
                InfoParagraph(
                    "We keep your data only as long as your account is active or as needed to provide the service, " +
                        "and we protect it with industry-standard technical and organisational measures, including " +
                        "encrypted connections."
                )
            }
            InfoSection("9. Changes to this policy") {
                InfoParagraph(
                    "We may update this policy as the service evolves. If changes are material, we will notify you " +
                        "through the service before they take effect."
                )
            }
            InfoSection("10. Contact") {
                InfoParagraph(
                    "For privacy questions or requests, contact us through the Supports link in the footer."
                )
            }
        }
    }
}
